// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "service-2Vf0E";
var _3 = "service__icon-2nX57";
var _4 = "service__info-20IHz";
var _5 = "service__name-14Due";
var _6 = "service__description-3ClxA";
export { _1 as "__esModule", _2 as "service", _3 as "service__icon", _4 as "service__info", _5 as "service__name", _6 as "service__description" }
export default { "__esModule": _1, "service": _2, "service__icon": _3, "service__info": _4, "service__name": _5, "service__description": _6 }
